import apiClient from "./apiClient";

export const getAllCategory = async (page, per_page) => {
  try {
    const response = await apiClient.get(
      `/admin/categories?page=${page}&per_page=${per_page}`,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCategory = async (data) => {
  try {
    const response = await apiClient.post("/admin/categories", data, {
      headers: {
        organization_id: 1,
        website_id: 1,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCategory = async (id, data) => {
  try {
    const response = await apiClient.put(`/admin/categories/${id}`, data, {
      headers: {
        organization_id: 1,
        website_id: 1,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await apiClient.delete(`/admin/categories/${id}`, {
      headers: {
        organization_id: 1,
        website_id: 1,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
